import { useEffect } from 'react'
import { chunkReloadStorageKey, tryOneTimeChunkReload } from '@/shared/monitoring/chunkLoadRecovery'

declare global {
  interface Window {
    /** Exposto para Playwright E2E resetar o debounce de abertura de PDF (1500 ms). */
    __synapResetPrescriptionPdfDebounce?: () => Promise<void>
    __synapChunkLoadRecovery?: {
      tryOneTimeChunkReload: (
        release: string,
        options?: { reload?: () => void },
      ) => boolean
      chunkReloadStorageKey: typeof chunkReloadStorageKey
    }
  }
}

/**
 * Expõe hooks mínimos para testes E2E reais (Playwright).
 * Inofensivo em produção — só executa quando o teste chama via `page.evaluate`.
 *
 * O módulo de PDF (jsPDF + assets, ~450 KB) é importado só quando o teste chama o reset: um
 * import estático aqui o colocava no chunk inicial de todo usuário.
 */
export function E2EPlaywrightBridge() {
  useEffect(() => {
    window.__synapResetPrescriptionPdfDebounce = async () => {
      const { _resetPrescriptionPdfDebounce } = await import('@/shared/lib/prescriptionPdf')
      _resetPrescriptionPdfDebounce()
    }
    window.__synapChunkLoadRecovery = {
      tryOneTimeChunkReload,
      chunkReloadStorageKey,
    }
    return () => {
      delete window.__synapResetPrescriptionPdfDebounce
      delete window.__synapChunkLoadRecovery
    }
  }, [])
  return null
}
